'use strict';

import vertex from './vertex.glsl';
import fragment from './fragment.glsl';


export const LuminanceShader = {
	name: 'LuminanceShader',
	defines: {},
	uniforms: {
		tDiffuse: {
			value: null
		}
	},
	vertexShader: vertex,
	fragmentShader: fragment
};
